module.exports = __webpack_public_path__ + "static/media/geolocalizacion1.ec944f30.svg";